import type { AddFieldOption } from '@cli-types/core-engine/add-field.js'
import { slugify, toTitleCase } from '@cli-utils/text.js'

export function parseInteractiveOptionsList(value: string): AddFieldOption[] {
  const labels = value.split(',').map(toTitleCase).filter(Boolean)

  if (labels.length === 0) {
    throw new Error('Enter option labels separated by commas.')
  }

  const options = labels.map((label) => ({
    value: slugify(label),
    label
  }))
  const seen = new Set<string>()
  for (const option of options) {
    if (!option.value) {
      throw new Error(`Invalid option label "${option.label}". Use letters or numbers.`)
    }
    if (seen.has(option.value)) {
      throw new Error(`Duplicate option value "${option.value}".`)
    }
    seen.add(option.value)
  }

  return options
}
